import React from "react";
import Link from "next/link";
import FadeInAnimation from "../Common/FadeInAnimation";
import { useTranslations } from '../../locales/useTranslations';
import { BiLogoVisualStudio, BiMobile, BiLogoWordpress, BiBuildings, BiChevronRight } from "react-icons/bi";

const WebentwicklungWeitereServices = () => {
  const { t } = useTranslations();
  return (
    <>
      <div className="services-area ptb-70">
        <div className="container">
          <div className="section-title text-left">
            <span className="sub-title">{t('webDevelopment_moreServices_subtitle')}</span>
            <h2>{t('webDevelopment_moreServices_title')}</h2>
          </div>

          <FadeInAnimation direction="up" delay={100}>
            <div className="container">
              <div className="row">
                <div className="col-sm-6">
                  <Link href="/app-development" className="read-more">
                    <div className="features-box">
                      <div className="icon">
                        <BiMobile />
                      </div>
                      <h3>{t('webDevelopment_moreServices_app_title')}</h3>
                      <p dangerouslySetInnerHTML={{ __html: t('webDevelopment_moreServices_app_description') }} />
                      <span className="features-box-action">{t('webDevelopment_moreServices_app_readMore')}
                      <BiChevronRight />
                      </span>
                      <div className="back-icon">
                        <BiMobile />
                      </div>
                    </div>
                  </Link>
                </div>

                <div className="col-sm-6">
                  <Link href="/software-development" className="read-more">
                    <div className="features-box">
                      <div className="icon">
                        <BiLogoVisualStudio />
                      </div>
                      <h3>{t('webDevelopment_moreServices_software_title')}</h3>
                      <p dangerouslySetInnerHTML={{ __html: t('webDevelopment_moreServices_software_description') }} />
                      <span className="features-box-action">{t('webDevelopment_moreServices_software_readMore')}
                      <BiChevronRight />
                      </span>
                      <div className="back-icon">
                        <BiLogoVisualStudio />
                      </div>
                    </div>
                  </Link>
                </div>

                <div className="col-sm-6">
                  <Link href="/web-development/wordpress-entwicklung/" className="read-more">
                    <div className="features-box">
                      <div className="icon">
                        <BiLogoWordpress />
                      </div>
                      <h3>{t('webDevelopment_moreServices_wordpress_title')}</h3>
                      <p dangerouslySetInnerHTML={{ __html: t('webDevelopment_moreServices_wordpress_description') }} />
                      <span className="features-box-action">{t('webDevelopment_moreServices_wordpress_readMore')}
                      <BiChevronRight />
                      </span>
                      <div className="back-icon">
                        <BiLogoWordpress />
                      </div>
                    </div>
                  </Link>
                </div>

                <div className="col-sm-6">
                  <Link href="/it-consulting" className="read-more">
                    <div className="features-box">
                      <div className="icon">
                        <BiBuildings />
                      </div>
                      <h3>{t('webDevelopment_moreServices_it_title')}</h3>
                      <p dangerouslySetInnerHTML={{ __html: t('webDevelopment_moreServices_it_description') }} />
                      <span className="features-box-action">{t('webDevelopment_moreServices_it_readMore')}
                      <BiChevronRight />
                      </span>
                      <div className="back-icon">
                        <BiBuildings />
                      </div>
                    </div>
                  </Link>
                </div>

              </div>
            </div>
          </FadeInAnimation>
        </div>
      </div>

    </>
  );
};

export default WebentwicklungWeitereServices;
